<!-- 思想政治 -->
<template>
  <div class="ideo">
    <van-tabs v-model="activeName" @click="slectKind">
      <van-tab
        :title="item.name"
        :name="item.channel_id"
        v-for="(item, index) in list"
        :key="index"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <Recommend v-for="(item, index) in lists" :key="index" :item="item">
              <template #title>
                <span>{{ item.title }}</span>
              </template>
              <template #author>
                <span>{{ item.author }}</span>
              </template>
              <template #time>
                <span>{{ item.create_time }}</span>
              </template>
              <template #img>
                <img :src="item.cover" class="tj-right" />
              </template>
              <template #player>
                <img
                  src="@/assets/img/home/palyer.png"
                  class="tj-player"
                  v-show="item.type == 2"
                />
              </template>
            </Recommend>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
    <div class="backs" @click="back" v-show="routeName == 'Ideology'">
      <img src="@/assets/img/home/toBack.png" />
    </div>
  </div>
</template>

<script>
import Recommend from "./top";
import { getKinds, getArticle } from "@/api/apiData";
import { Toast } from "vant";
export default {
  components: { Recommend },
  data() {
    return {
      activeName: "",
      list: [],
      page: 0, //当前页码
      offset: 10, //当前页面条目数
      totalPages: 1, //总页码
      lists: [], //文章数组
      loading: false,
      finished: false,
      refreshing: false,
      routeName: "",
    };
  },
  computed: {},
  methods: {
    back() {
      this.$router.back();
    },
    // 获取思想政治栏目分类
    getLists() {
      var that = this;
      const routeName = that.routeName;

      if (routeName == "Ideology") {
        var parent_id = 1;
      } else if (routeName == "Life") {
        var parent_id = 12;
      } else {
        var parent_id = 10;
      }
      getKinds({ parent_id: parent_id }).then((res) => {
        // //(res);
        if (res.code == 1) {
          that.list = res.data;
        } else {
          Toast(res.msg);
        }
      });
    },
    // 选择分类
    slectKind() {
      var that = this;
      that.lists = [];
      that.page = 0;
      that.offset = 10;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.getList();
    },
    // 上拉记载
    onLoad() {
      this.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.lists = [];
      that.page = 0;
      that.offset = 10;
      that.totalPages = 1;
      that.loading = false;
      that.finished = false;
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 1500);
    },
    // 获取文章列表
    getList() {
      var that = this;
      var page = that.page + 1;
      var lists = that.lists;
      var totalPages = that.totalPages;
      var offset = that.offset;
      var channel_id = that.activeName;
      // 参数
      let obj = {
        page: page,
        offset: offset,
        channel_id: channel_id,
      };
      if (totalPages >= page) {
        getArticle(obj).then((res) => {
          // //(res);
          if (res.code == 1) {
            that.page = page;
            that.lists = lists.concat(res.data.list);
            that.totalPages = Math.ceil(
              Number(res.data.total) / res.data.length
            );
            if (res.data.list.length == 0) {
              //数据请求成功 但是无数据
              that.finished = true;
              that.loading = false;
              return false;
            }
            if (that.lists.length >= lists.length) {
              // 数据请求成功后  停止加载状态
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          }
        });
      } else {
        // 全部数据加载完毕
        that.finished = true;
      }
    },
  },
  created() {
    this.routeName = this.$route.name;
  },
  mounted() {
    this.getLists();
  },
};
</script>
<style lang='less' scoped>
.ideo {
  background: #fff;
}
/deep/.van-tabs__wrap {
  height: 0.8rem;
}
/deep/.van-tabs__nav--line {
  border-bottom: 0.01rem solid #ebedf0;
  padding-bottom: 0;
  .van-tab {
    font-size: 0.28rem;
    font-weight: 400;
    line-height: 0.4rem;
    color: rgba(128, 128, 128, 1);
  }
  .van-tab--active {
    font-size: 0.36rem;
    font-weight: bold;
    line-height: 0.5rem;
    color: rgba(51, 51, 51, 1);
  }
  .van-tabs__line {
    bottom: 0;
    width: 0.5rem !important;
    background: #ff4343;
    height: 0.03rem;
  }
}
.backs {
  position: fixed;
  bottom: 5%;
  right: 5%;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  box-shadow: 0 0 0.05rem 0.01rem rgba(21, 21, 21, 0.3);
  z-index: 10;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 0.5rem;
    height: 0.5rem;
  }
}
</style>